module.exports = __webpack_public_path__ + "static/img/一键报税.d9d05282.png";